export default {"src":"/_next/static/media/logo.a40ce6db.svg","height":63,"width":117,"blurWidth":0,"blurHeight":0};